var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 3.5C4.84315 3.5 3.5 4.84314 3.5 6.5V13.4524C3.5 14.7586 4.33481 15.8698 5.5 16.2817V8.5C5.5 6.84314 6.84315 5.5 8.5 5.5H16.2817C15.8698 4.33481 14.7586 3.5 13.4524 3.5H6.5Z",
    fill: "#2496FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.54761,
    y: 7.54761,
    width: 12.9524,
    height: 12.9524,
    rx: 3,
    fill: "#2496FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2fd90e6ec25892e7b2a45346d5dccefa.svg";
export { ForwardRef as ReactComponent };